import { hasLocale, resolveLinkLocale } from "utilities/locale";
import { navigate as GatsbyNavigate } from "gatsby";

const navigateBack = () => {
  if (window.location.href.includes("/contest/")) {
    navigate("/pickems/");
  } else {
    GatsbyNavigate(-1);
  }
  return false;
};

const normalizePathname = (value: string) => {
  if (!value) return "/";

  const prefix = value.startsWith("/") ? "" : "/";
  const postfix = value.endsWith("/") ? "" : "/";

  return `${prefix}${value}${postfix}`;
};

const splitPath = (value: string) => {
  // Match a path as: [pathname][?query][#hash]
  const match = value.match(/^([^?#]*)(\?[^#]*)?(#.*)?$/);

  // match[0] is the full string, doesn't need to be included
  return {
    pathname: match?.[1] || "/",
    search: match?.[2] || "",
    hash: match?.[3] || "",
  };
};

const navigate = (
  to = "/",
  noLang = false,
  options: { replace?: boolean } = {},
) => {
  const { pathname, search, hash } = splitPath(to);
  let prefix = "";

  if (
    typeof window !== "undefined" &&
    !noLang &&
    !hasLocale(to, window.___currentLocale)
  ) {
    const targetLocale = resolveLinkLocale(to, window.___currentLocale);
    prefix = targetLocale === window.___defaultLocale ? "" : `/${targetLocale}`;
  }

  const path = `${prefix}${normalizePathname(pathname)}${search}${hash}`;

  return GatsbyNavigate(path, options);
};

export { navigate, navigateBack };
